const RICOS_VERSION = "10.146.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
